module.exports = __webpack_public_path__ + "static/img/3106_phase_function_Paper_Points.e186850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3106_phase_function_Paper_Points.png
// module id = Y76G
// module chunks = 0